import { Box, Button, Form, Icon, Spacer, Text } from '@jfs/ui-new'
import { useNavigation } from '@react-navigation/native'
import { observer } from 'mobx-react'
import { FC, ReactElement, useEffect } from 'react'
import { DefaultFormContainer } from '../../comps/DefaultFormContainer'
import { ModBox } from '../../comps/ModifiedBox/ModifiedBox'
import { forgotPwdStrings, loginStrings } from '../../data/static/strings'
import { useLazyApiData, useStores } from '../../data/store'
import { Routes } from '../../nav/routes'
import { useIsMobile } from '../../util/useFontSize'
import { isOsMobile, storeData, testProps, useWindowDimensions } from '../../util/util'
import { LoginBg } from '../Login/LoginBg'
import ForgotPasswordMobile from './ForgotPasswordMobile'
import { formData } from './FormData'
import { styles } from './styles'

interface ForgotpasswordProps {
  hide?: boolean
}

const ForgotPassword: FC<ForgotpasswordProps> = ({ hide }: ForgotpasswordProps) => {
  const viewPortWidth = useWindowDimensions()

  const { userObj, mobileNum, updateMobile } = useStores((root) => ({
    userObj: root.user.generateOtp,
    mobileNum: root.settings.metaData.mobileNumber,
    updateMobile: root.settings.metaData.updateMobileNumber,
  }))
  const [generateOtp, { state, data }] = useLazyApiData(userObj)
  const navigation = useNavigation()

  useEffect(() => {
    console.log('===> ForgotPassword generateOtp state', state)
    if (state === 'fulfilled') {
      navigation?.navigate(Routes.OTP, {
        path: Routes.OTP,
        isSignUp: false,
        mobileNum: mobileNum,
        isFromForgotPwd: true,
      })
    }
    if (data?.message) {
    }
  }, [data, mobileNum, navigation, state])

  const renderActionButtons = ({ handleSubmit, values, isValid }: any): ReactElement => {
    const handleResetPress = (): void => {
      handleSubmit()
      updateMobile(values.mobileNumber)
      storeData(loginStrings.userMobileNumber, values.mobileNumber)
      if (values.mobileNumber.length === 10 || isValid) {
        generateOtp(values.mobileNumber)
      }
    }
    return (
      <Box {...styles.buttonContainer}>
        <Button
          isFull
          isLoading={state === 'pending'}
          disabled={values.mobileNumber.length !== 10}
          type={'primary'}
          color={'BLUE'}
          {...testProps('send-otp-button')}
          onPress={handleResetPress}>
          <Text color={'WHITE'} fontWeight="bold">
            {forgotPwdStrings.sendOtp}
          </Text>
        </Button>
      </Box>
    )
  }

  const checkNGetNumberFromStorage = (): string => {
    return mobileNum
  }

  const handleBack = (): void | undefined => {
    navigation?.goBack()
  }

  const isMobile = useIsMobile()
  if (hide) {
    return null
  } else if (isMobile) {
    return <ForgotPasswordMobile hide={hide} onPress={() => navigation.navigate('signin')} />
  } else {
    return (
      <LoginBg isSignup={false}>
        <Box
          p={16}
          minWidth={viewPortWidth > 432 ? 320 : viewPortWidth - 36}
          minHeight={viewPortWidth > 432 ? 280 : undefined}
          justifyContent="center">
          <ModBox show={isOsMobile()} onPress={handleBack} {...testProps('back-button')} {...styles.imgStyle}>
            <Icon id={'ARROW_BACK'} color={'PRIMARY'} size={24} />
          </ModBox>
          <Box ph={8} underlayColor="WHITE">
            <Text {...styles.titleStyle}>{forgotPwdStrings.forgotPassword}</Text>
            <Spacer size={10} direction={'vertical'} />
            <Text {...styles.subTitleStyle}>{forgotPwdStrings.weWillSendOtpToNum}</Text>
            <Spacer size={20} />
            <Box {...styles.formContainer}>
              <Form
                initialValues={{
                  mobileNumber: checkNGetNumberFromStorage(),
                }}
                container={DefaultFormContainer}
                formData={formData(mobileNum ?? '')}
                actionButtons={renderActionButtons}
              />
            </Box>
          </Box>
        </Box>
      </LoginBg>
    )
  }
}

export default observer(ForgotPassword)
